import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import { Paper, Typography } from '@material-ui/core';
import ProfileForm from '../containers/ProfileForm/ProfileForm';
import ChangePasswordForm from '../containers/ChangePasswordForm/ChangePasswordForm';

const styles = theme => ({
  resetBox: {
    marginTop: theme.spacing.unit * 5,
  },
  paper: {
    padding: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit,
  },
  paperBottom: {
    padding: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 3,
  },
});

const propTypes = {
  classes: PropTypes.oneOfType([PropTypes.object]).isRequired,
  authStore: mobxPropTypes.observableObject.isRequired,
};

const ProfilePage = ({ classes, authStore }) => (
  <div>
    <Paper className={classes.paper}>
      <ProfileForm user={authStore.user} />
    </Paper>

    <div className={classes.resetBox}>
      <Typography variant="headline">
        Change Password
      </Typography>
      <Paper className={classes.paperBottom}>
        <ChangePasswordForm />
      </Paper>
    </div>
  </div>
);

ProfilePage.propTypes = propTypes;
const ProfileStyled = withStyles(styles, { withTheme: true })(ProfilePage);
export default inject('authStore', 'snackbarStore')(observer(ProfileStyled));



// WEBPACK FOOTER //
// ./src/pages/Profile.js